import { render, staticRenderFns } from "./newCogIcon.vue?vue&type=template&id=8cbdd114"
import script from "./newCogIcon.vue?vue&type=script&lang=js"
export * from "./newCogIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports